import { Tournament } from "@/graphql"

/**
 * Formateamos la fecha.
 */
export const formatDate = (dateString: string) => {
  if (!dateString) {
    return ""
  }
  const d = new Date(dateString).toLocaleDateString("es-ES", {
    weekday: "long",
    year: "numeric",
    month: "long",
    day: "numeric",
  })
  return d
}

/**
 * Obtenemos la imagen cover del torneo.
 */
export const getTournamentImage = (tournament: Tournament) => {
  let tournamentTypeImage = tournament.TournamentType?.urlImage
  switch (tournament.gameId) {
    case 1: // Imperio
      tournamentTypeImage = tournament.TournamentType?.urlImage
      break
    case 4: // Primer Bloque
      tournamentTypeImage = tournament.TournamentType?.urlImage3
      break
    case 6: // Primera Era
      tournamentTypeImage = tournament.TournamentType?.urlImage4
      break
    case 11: // Furia Extendido
      tournamentTypeImage = tournament.TournamentType?.urlImage2
      break
  }
  const image = tournamentTypeImage || tournament.Game?.urlImage
  return image
}

/**
 * Generamos el extract de un texto.
 */
export const getExtract = (text: string, maxWords = 40): string => {
  if (!text) {
    return ""
  }
  const words = text?.split(/\s+/)
  if (words && words.length <= maxWords) {
    return text
  }
  const extract = words?.slice(0, maxWords).join(" ")
  return `${extract}... ver más`
}
